<template>
  <div
    ref="legoDropdown"
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-dropdown-click-outside="toggleItemOuter"
  >
    <div
      class="lego-dropdown__title"
      :class="{ 'lego-dropdown--focused': isFocused }"
      :style="customTitleStyle"
      :tabindex="autoComplete || checkDisabled ? -1 : 0"
      @click="toggleItem"
    >
      <div
        class="lego-dropdown__selected"
        :style="dropdownTitleStyle"
        :class="{ placeholder: placeholder && !modelValue }"
        v-lego-tooltip:ellipsis="getText(selItem)"
      >
        <span v-lego-tooltip:ellipsis="getText(selItem)">
          <!--
                    $ver: v0.1.2
                    드랍다운 항목 내부에 위치하는 영역 입니다.
                    #This area is located inside the dropdown item.
          -->
          <slot name="itemText" :item="selItem" :getText="getText">
            {{ getText(selItem) }}
          </slot>
        </span>
      </div>
      <lego-icon-wrapper class="lego-dropdown__title-icon">
        <lego-icon
          class="lego-dropdown__icon"
          icon-type="df"
          icon="arrow_down"
          :size="16"
          :style="caretStyle"
        />
      </lego-icon-wrapper>
    </div>
    <lego-dropdown-menu
      :items="items"
      :isItemShowing="isItemShowing"
      :autoComplete="autoComplete"
      :autoCompleteText="autoCompleteText"
      :autoCompletePlaceholder="autoCompletePlaceholder"
      :width="itemWidth"
      :hasScroll="hasScroll"
      :itemMaxHeight="itemMaxHeight"
      :filteredItemList="filteredItemList"
      :itemValue="itemValue"
      :itemText="itemText"
      :selectedItem="selItem"
      :focusedItemIndex="focusedItemIndex"
      :focusedDepthIndex="focusedDepthIndex"
      :appendToBody="appendToBody"
      :menuDirection="menuDirection"
      :small="sm || small"
      :shadow="menuShadow"
      :customButtonText="customButtonText"
      :noDataText="noDataText"
      :groups="groups"
      :groupSort="groupSort"
      :autoSearch="autoSearch"
      :searchable="searchable"
      :counter="counter"
      parent="legoDropdown"
      @click="clickItem"
      @close="toggleItemOuter"
      @customButtonClick="customButtonClick"
      @changeAutoCompleteText="onInput"
      :capitalize="capitalize"
    />
    <div
      v-if="messageShow"
      class="lego-dropdown__message lego-validator__message"
      :class="messageClass"
      :style="customValidationStyle"
    >
      <!--glue
      -->
      {{ messageShow }}
      <!--glue
      -->
    </div>
  </div>
</template>
<script>
import legoDropdownMenu from './legoDropdownMenu';
import i18nMixin from '@/mixins/i18n.mixin.js';
import { number } from 'echarts/core';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

const DEFAULT_ITEM_VALUE = 'value';

export default {
  mixins: [i18nMixin],
  components: {
    legoDropdownMenu
  },
  emits: ['show-dropdown', 'onToggle', 'customButtonClick'],
  props: {
    isCheckScroll: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    // 선택 옵션 기본 추가. 해당 선택 클릭 시 return value는 ''.
    select: {
      type: Boolean,
      default: false
    },
    borderLess: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    counter: {
      type: [String, Number],
      default: undefined
    },
    menuDirection: {
      type: String,
      default: 'left'
    },
    titleStyle: {
      type: Object,
      default: () => {}
    },
    titleActiveStyle: {
      type: Object,
      default: () => {}
    },
    menuShadow: {
      type: Boolean,
      default: false
    },
    itemMaxHeight: {
      type: [Number, String],
      default: 272
    },
    customButtonText: {
      type: String,
      default: ''
    },
    noDataText: {
      type: String,
      default: ''
    },
    autoCompletePlaceholder: {
      type: String,
      default: ''
    },
    groups: {
      type: Array,
      default: () => []
    },
    groupSort: {
      type: Boolean,
      default: false
    },
    isShowTooltip: {
      type: Boolean,
      default: false
    },
    isASGTemplate: {
      type: Boolean,
      default: false
    },
    autoSearch: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    capitalize: {
      type: Boolean,
      default: false
    },
    hasScroll: {
      type: Number
    }
  },
  watch: {
    items() {
      this.setDefault();
    },
    isCheckScroll(val) {
      if (val) this.isItemShowing = false;
    }
  },
  data() {
    return {
      default: {
        size: 'medium',
        placeholder: this.t('label.notSelect')
      }
    };
  },
  mounted() {
    this.setDefault();
    legoEventBus.$on('click-outside', this.toggleItemOuter);
    legoEventBus.$on('close_tooltips', this.toggleItemOuter);
  },
  beforeUnmount() {
    legoEventBus.$off('click-outside', this.toggleItemOuter);
    legoEventBus.$off('close_tooltips', this.toggleItemOuter);
  },
  computed: {
    dropdownClass() {
      return {
        'lego-dropdown--open': this.isItemShowing,
        'lego-dropdown--readonly': this.readOnly,
        'lego-dropdown--disabled': this.disabled,
        'lego-dropdown--medium': this.$_size === 'medium',
        'lego-dropdown--small': this.$_size === 'small',
        'lego-dropdown--up': this.up,
        'lego-dropdown--borderless': this.borderLess,
        'lego-validator--error': this.hasError === true,
        'lego-validator--valid': this.showValid && this.hasError === false,
        'lego-validator--shake': this.shake
      };
    },
    customTitleStyle() {
      if (this.isItemShowing || this.isFocused) {
        return this.titleActiveStyle;
      } else {
        return this.titleStyle;
      }
    },

    checkDisabled() {
      if (this.disabled) {
        this.isItemShowing = false;
      }

      return this.disabled;
    }
  },
  methods: {
    toggleItem() {
      this.isItemShowing = !this.isItemShowing;
      if (this.autoComplete) {
        this.autoCompleteText = '';
        this.onFilter(this.autoCompleteText);
      }

      this.$emit('onToggle', 'toggle');
      if (this.isItemShowing) this.$emit('show-dropdown');
    },
    getText(item) {
      if (!item)
        return this.autoComplete ? this.placeholder : this.placeholder || this.default.placeholder;
      let itemText = '';
      if (typeof this.itemText === 'function') {
        itemText = this.itemText(item);
      } else {
        itemText = item[this.itemText];
      }
      if (itemText === undefined || itemText === null) {
        return item;
      } else {
        return itemText;
      }
    },
    setDefault() {
      if (this.items && this.items.length > 0) {
        if (
          this.select &&
          this.items[0][
            this.inputValue || (this.itemValue !== 'object' && this.itemValue) || DEFAULT_ITEM_VALUE
          ] !== ''
        ) {
          const selectObject = {};
          selectObject[this.itemText] = this.$msg('domain.please-select', '-- Select --');
          selectObject[
            this.inputValue || (this.itemValue !== 'object' && this.itemValue) || DEFAULT_ITEM_VALUE
          ] = '';
          this.items.unshift(selectObject);
        }
      }
    },
    customButtonClick(button) {
      this.$emit('customButtonClick', button);
    },
    onInput(value) {
      this.autoCompleteText = value;
      this.onFilter(value);
    }
  }
};
</script>
<style lang="scss" scoped>
.lego-dropdown {
  min-width: 80px;
  &__title {
    border-radius: 2px;
    .lego-dropdown__selected {
      width: calc(100% - 24px);
      span {
        display: inline-block;
        @include ellipsis;
      }

      &.placeholder {
        color: $color--ui06;
      }
    }
  }

  &__title-icon {
    .lego-dropdown__icon {
      font-size: 12px;
    }
  }

  .lego-dropdown__title {
    &:focus {
      border: $lego-dropdown__title__border;
    }
    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
  }

  &--borderless {
    width: auto;
    min-width: auto;
    .lego-dropdown__title {
      border: 0 !important;

      .lego-dropdown__selected {
        flex-grow: 1;
      }
    }

    &.lego-dropdown--disabled {
      .lego-dropdown__title {
        background: none !important;
      }
    }
  }

  &--readonly {
    pointer-events: none;
    cursor: default;
    .lego-dropdown__title {
      border: $lego-dropdown__title__border--disabled;
      background-color: $lego-dropdown__title__background-color--readonly;
    }
  }

  &--small {
    min-width: $lego-dropdown__min-width--small;
    .lego-dropdown__title-icon {
      .lego-dropdown__icon {
        font-size: 10px;
      }
    }
  }
}
</style>
